// i18n area 'tasks' — locale is-IS (task #171, ratifica Luca 2026-08-04: l'islandese
// entra come 28ª lingua, in aggiunta al piano): tradotto DALL'ITALIANO, che è la
// lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del sorgente si
// TRASLANO secondo l'uso vivo islandese (la lingua più nativizzante del canone:
// verk, öryggisafrit, sniðmát). Sidecar anti-stantie: ../meta/tasks.is-IS.meta.json.
import type { enUS } from './tasks'

export const isIS: typeof enUS = {
  macrotasks: {
    title: 'Makróverk',
    subtitle: 'Samsettar aðgerðir — hægt að halda áfram frá misheppnaða skrefinu eða hætta við allt',
    colType: 'Tegund',
    colTarget: 'Viðfang',
    colPhase: 'Fasi',
    colSteps: 'Skref',
    empty: 'Engin makróverk',
    detail: 'Nánar',
    failedAt: 'mistókst í',
    resume: 'Reyna aftur frá misheppnaða skrefinu',
    abort: 'Hætta við allt',
    cancel: 'Hætta við',
    actionError: 'Aðgerðinni var hafnað'
  },
  tasks: {
    title: 'Verk',
    searchPlaceholder: 'Leita eftir tegund eða viðfangi',
    type: 'Tegund',
    target: 'Viðfang',
    phaseLabel: 'Fasi',
    progress: 'Framvinda',
    started: 'Hafið',
    finished: 'Lokið',
    node: 'Hnútur',
    empty: 'Engin verk',
    loadError: 'Ekki tókst að sækja verkin — næst samband við TVirt-bakendann?',
    limboHint: "Hnútur '{node}' hefur verið ónáanlegur frá {time} — verkið heldur write lease á viðfangi sínu þar til hnúturinn kemur aftur eða er staðfestur slökktur",
    nodeAttested: 'Hnútur staðfestur slökktur',
    phase: {
      queued: 'Í biðröð',
      running: 'Í keyrslu',
      succeeded: 'Tókst',
      failed: 'Mistókst',
      cancelled: 'Hætt við',
      'failed-at-step': 'Mistókst í skrefi',
      aborted: 'Rofið'
    },
    dropdown: {
      tooltip: 'Verk í gangi',
      title: 'Verk í gangi',
      empty: 'Engin verk í gangi',
      viewAll: 'Sjá öll verk'
    },
    detail: {
      open: 'Nánar',
      scope: 'Umfang',
      message: 'Skilaboð',
      params: 'Stikur',
      result: 'Niðurstaða',
      errorTitle: 'Villa',
      steps: 'Skref',
      failedAt: 'mistókst í',
      superseded: 'leyst af hólmi',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Skref',
      parent: 'Foreldraverk',
      failedStep: 'Misheppnað skref',
      log: 'Annáll',
      logEmpty: 'Engar annálalínur enn',
      close: 'Loka'
    },
    actions: {
      cancel: 'Hætta við',
      resume: 'Reyna aftur frá misheppnaða skrefinu',
      abort: 'Hætta við allt (afturkalla lokin skref)',
      refused: 'Aðgerðinni var hafnað'
    }
  },
  events: {
    loadError: 'Ekki tókst að hlaða dagbókina — er TVirt-bakendinn aðgengilegur?',
    title: 'Atburðir',
    subtitle: 'Sögulegt minni klasans: orðnir hlutir, þeir nýjustu fyrst',
    filterSeverity: 'Alvarleiki',
    filterCategory: 'Flokkur',
    filterAll: 'Allir',
    searchLabel: 'Leita',
    searchPlaceholder: 'Leita í allri annálnum',
    subjectFilter: 'Atburðir {subject} — sýna alla',
    colAt: 'Hvenær',
    colSeverity: 'Alvarleiki',
    colType: 'Tegund',
    colSubject: 'Viðfang',
    colActor: 'Hver',
    colNode: 'Node',
    colMessage: 'Skilaboð',
    empty: 'Engir atburðir',
    loadMore: 'Hlaða fleirum',
    actorSystem: 'kerfi',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Auðkenni atburðar',
    taskCollectedHint: 'Task hefur styttri varðveislu: eftir söfnun svarar tengillinn ekki lengur',
    severity: {
      info: 'Upplýsingar',
      warning: 'Aðvörun',
      error: 'Villa',
      critical: 'Alvarlegt'
    },
    category: {
      lifecycle: 'Líftími',
      config: 'Stillingar',
      availability: 'Aðgengi',
      security: 'Öryggi'
    },
    type: {
      haNetsvcFailedOver: 'Failover netþjónustu',
      haNetsvcNoCandidate: 'Netþjónusta án hnúts til að taka við',
      haNetsvcReaped: 'Staðbundið eintak uppskorið við endurkomu hnútsins',
      netsvcFloatipMoved: 'Fljótandi IP færðist til annars handhafa',
      netsvcFloatipNoHolder: 'Fljótandi IP án heilbrigðs skotmarks',
      haAppFailedOver: 'Failover App-tilviks',
      haAppNoCandidate: 'App-tilvik án frambjóðandahnúts',
      haAppStorageLocalSkip: 'App-tilvik ekki flutt: varanleg gögn staðbundin á dauða hnútnum',
      haAppReaped: 'Staðbundið pod App-tilviks slegið við endurinngöngu'
    }
  },
  audit: {
    loadError: 'Ekki tókst að hlaða úttektarskrána — er TVirt-bakendinn aðgengilegur?',
    title: 'Úttekt',
    subtitle: 'Hver gerði hvað, hvenær og á hvaða viðfangi — tilraunir til verka, höfnunum meðtöldum',
    filterOutcome: 'Niðurstaða',
    filterAll: 'Allar',
    filterSudo: 'Aðeins upphafin verk',
    colAt: 'Hvenær',
    colActor: 'Hver',
    colAction: 'Aðgerð',
    colTarget: 'Viðfang',
    colOutcome: 'Niðurstaða',
    colNode: 'Node',
    empty: 'Engin verk skráð',
    loadMore: 'Hlaða fleirum',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Leið',
    detailProblem: 'Ástæða',
    detailTask: 'Task',
    detailClientIp: 'Frá',
    detailId: 'Auðkenni færslu',
    detailSession: 'Seta',
    taskHint: 'Niðurstaða samþykktrar aðgerðar býr í atburðadagbókinni, undir sama task-auðkenni',
    outcome: {
      succeeded: 'Tókst',
      accepted: 'Samþykkt',
      denied: 'Neitað',
      rejected: 'Hafnað',
      failed: 'Mistókst'
    }
  },
  notifications: {
    loadError: 'Ekki tókst að hlaða tilkynningarnar — er TVirt-bakendinn aðgengilegur?',
    actionError: 'Aðgerðinni var hafnað',
    title: 'Tilkynningar',
    subtitle: 'Áfangastaðirnir sem staðreyndir dagbókarinnar fara úr klasanum til',
    rulesTitle: 'Reglur',
    rulesSubtitle: 'Hvaða staðreyndir fara út og hvert',
    deliveriesTitle: 'Afhendingar',
    deliveriesSubtitle: 'Niðurstaða hverrar tilkynningar, með ástæðunni þegar hún mistekst',
    colName: 'Nafn',
    colKind: 'Tegund',
    colWhere: 'Hvert',
    colScope: 'Scope',
    colSeverity: 'Alvarleiki',
    colMatch: 'Sía',
    colTargets: 'Áfangastaður',
    colAt: 'Hvenær',
    colState: 'Staða',
    colEvent: 'Atburður',
    colAttempts: 'Tilraunir',
    colOutcome: 'Niðurstaða',
    empty: 'Engin lína',
    matchAll: 'allar staðreyndir',
    test: 'Prófa',
    testOk: 'Prófunartilkynning afhent til {target}',
    testFailed: 'Prófun til {target} mistókst: {reason}',
    retry: 'Setja aftur í röð',
    retried: 'Afhending sett aftur í röð',
    grouped: 'og {count} endurtekningar til viðbótar',
    state: {
      failed: 'Mistókst',
      pending: 'Í biðröð',
      sending: 'Í sendingu',
      sent: 'Send'
    },
    tabTargets: 'Áfangastaðir',
    tabRules: 'Reglur',
    tabDeliveries: 'Afhendingar',
    targetCreateTitle: 'Nýr áfangastaður',
    ruleCreateTitle: 'Ný regla',
    nameHint: 'Litlir stafir, tölur og bandstrik; einkvæmt á hverju umfangi',
    kindImmutableHint: 'Óbreytanlegt: að breyta gerðinni þýðir að búa til annan áfangastað',
    kindSmtp: 'Póstur (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Staða',
    enabledOn: 'Virkur',
    enabledOff: 'Í hléi',
    smtpHost: 'SMTP-þjónn',
    smtpPort: 'Gátt',
    smtpPortHint: 'Venjulega: 25 án TLS, 587 með starttls, 465 með tls',
    smtpSecurity: 'Öryggi',
    smtpFrom: 'Sendandi',
    smtpTo: 'Viðtakendur',
    smtpToHint: 'Eitt eða fleiri vistföng skilin með kommu',
    webhookUrl: 'URL',
    payload: 'Innihald',
    payloadHint: 'Með minimal fara skeyti og gögn viðburðarins ekki út úr klasanum',
    credential: 'Aðgangsupplýsingar',
    credentialNone: 'Engar',
    credentialHintSmtp: 'Notandi endurvarpans úr lyklageymslunni; engar þýðir ónefnt SMTP',
    credentialHintWebhook: 'Undirskriftarlykill úr lyklageymslunni; án undirskriftar getur hver sem þekkir URL-ið þóst vera klasinn',
    minSeverityHint: 'Þröskuldur, ekki mengi: frá þessu alvarleikastigi og upp',
    categories: 'Flokkar',
    categoriesHint: 'Tómt = allir',
    types: 'Viðburðagerðir',
    typesHint: 'Skilið með kommu; tómt = allir. Óþekkt gerð er hafnað',
    targetsHint: 'Að minnsta kosti einn; þeir verða að vera í umfangi reglunnar eða forvera hennar',
    recursiveOn: 'Einnig undirumföng',
    recursiveOff: 'Aðeins þetta umfang',
    recursiveHint: 'Tilfangi lifa í blöðunum: án barnanna tilkynnir regla á rótinni nánast ekkert',
    repeatWindow: 'Hópunargluggi (s)',
    repeatWindowHint: 'Innan gluggans senda endurtekningar engan póst: þær eru taldar á fyrstu. 0 slekkur',
    targetInUseError: 'Áfangastaðurinn {name} er enn í notkun af reglu'
  }
}
